import { MapPin, Phone, Mail, Clock, Heart, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_asilo-peramore/artifacts/qzmvlqzx_0945cabc-d0c0-4609-956c-55e1e91721a9.jpeg";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
  else window.location.href = "/#" + id;
};

const openCookiePrefs = () => window.dispatchEvent(new Event("open-cookie-preferences"));

export const CTABanner = () => (
  <section data-testid="cta-banner" className="bg-rose-500">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
      <h2 className="font-heading text-3xl sm:text-4xl font-800 text-white">Vuoi saperne di più?</h2>
      <p className="mt-3 text-rose-50 font-600 text-lg">Saremo felici di accoglierti e rispondere a ogni tua domanda.</p>
      <button data-testid="cta-banner-btn" onClick={() => go("contatti")}
        className="mt-6 rounded-full bg-white text-rose-600 px-9 py-4 font-800 hover:-translate-y-0.5 transition-all shadow-lg">
        Contattaci
      </button>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-slate-900 text-slate-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
      <div>
        <img src={LOGO} alt="Logo Per Amore" className="h-20 w-auto bg-white rounded-2xl p-2" />
        <p className="mt-4 text-slate-400 font-600 max-w-xs">
          Un luogo dove ogni giorno nasce una nuova scoperta, un nuovo sorriso e un nuovo ricordo da custodire.
        </p>
      </div>
      <div>
        <h4 className="font-heading text-lg font-700 text-white">Naviga</h4>
        <ul className="mt-4 space-y-2">
          {[["chi-siamo","Chi Siamo"],["progetto","Progetto"],["giornata","Giornata Tipo"],["gallery","Gallery"],["iscrizioni","Iscrizioni"],["calendario","Calendario"],["contatti","Contatti"]].map(([id,l]) => (
            <li key={id}>
              <button data-testid={`footer-nav-${id}`} onClick={() => go(id)} className="font-600 text-slate-400 hover:text-rose-300 transition-colors">{l}</button>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-heading text-lg font-700 text-white">Contatti</h4>
        <ul className="mt-4 space-y-3 font-600">
          <li className="flex items-start gap-3"><MapPin className="h-5 w-5 text-rose-400 mt-0.5" /> Via Strasburgo 3/b, San Donato Milanese 20097</li>
          <li className="flex items-center gap-3"><Phone className="h-5 w-5 text-emerald-400" /> 338 734 8963</li>
          <li className="flex items-center gap-3"><Mail className="h-5 w-5 text-sky-400" /> asilonidoperamore@gmail.com</li>
          <li className="flex items-center gap-3"><Clock className="h-5 w-5 text-amber-400" /> Lun – Ven, 8:00 – 18:00</li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading text-lg font-700 text-white">Legale</h4>
        <ul className="mt-4 space-y-2">
          <li>
            <Link to="/privacy-policy" data-testid="footer-privacy-policy" className="font-600 text-slate-400 hover:text-rose-300 transition-colors">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/cookie-policy" data-testid="footer-cookie-policy" className="font-600 text-slate-400 hover:text-rose-300 transition-colors">Cookie Policy</Link>
          </li>
          <li>
            <button data-testid="footer-manage-cookies" onClick={openCookiePrefs}
              className="inline-flex items-center gap-2 font-600 text-slate-400 hover:text-rose-300 transition-colors">
              <Cookie className="h-4 w-4" /> Gestisci preferenze cookie
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500 font-600">
        <p>© {new Date().getFullYear()} Asilo Nido Per Amore. Tutti i diritti riservati.</p>
        <p className="inline-flex items-center gap-1.5">Fatto con <Heart className="h-4 w-4 fill-rose-500 text-rose-500" /> per i più piccoli</p>
      </div>
    </div>
  </footer>
);
